import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { SegmentedControls } from '@uhg-abyss/web/ui/SegmentedControls';
import { styled } from '@uhg-abyss/web/tools/styled';
const StyledTab = styled(SegmentedControls.Tab, {
  borderRadius: '0px !important',
  padding: '4px',
});

const LANGUAGE_LABELS = {
  curl: 'cURL',
  http: 'HTTP',
  java: 'Java',
  javascript: 'JavaScript',
  nodejs: 'NodeJS',
  python: 'Python',
  csharp: 'C#',
  php: 'PHP',
};

export const LanguageSelect = ({
  languages,
  setSelectedLanguage,
  selectedLanguage,
}) => {
  const languageOptions = useMemo(() => {
    const languagesToUse = languages || Object.keys(LANGUAGE_LABELS);
    return languagesToUse.map((item) => {
      return {
        value: item,
        label: LANGUAGE_LABELS[item] || item,
      };
    });
  }, [languages]);

  return (
    <SegmentedControls
      title="Select a Language"
      value={selectedLanguage}
      onChange={setSelectedLanguage}
      css={{
        'abyss-segmented-controls-tabs-container': {
          borderRadius: '8px',
          backgroundColor: '#F0F4F8',
          border: 'none',
        },
        'abyss-segmented-controls-selected-background': {
          borderRadius: '8px',
          backgroundColor: '#196ECF',
          border: 'none',
          color: '#ffffff !important',
        },
      }}
    >
      {languageOptions?.map((item) => {
        return (
          <StyledTab key={item.value} label={item.label} value={item.value} />
        );
      })}
    </SegmentedControls>
  );
};

LanguageSelect.propTypes = {
  languages: PropTypes.arrayOf(PropTypes.string),
  setSelectedLanguage: PropTypes.func.isRequired,
  selectedLanguage: PropTypes.string,
};

LanguageSelect.defaultProps = {
  languages: [],
  selectedLanguage: '',
};
